const SearchModule = (function($) {
    const getDomElements = () => ({
        searchDropdown: $('.search-dropdown'),
        mainSearchDropdown: $('#main-search-dropdown-trigger'),
        searchInput: $('#main-search-input'),
        searchButton: $('.search_cms'),
        searchDropdownOutside: $('#search-dropdown-menu-outside'),
        removeValueButton: $('#search-dropdown-menu-outside button'),
        mainHeaderText: $('.mainHeader .text')
    });

    const activateSearch = (elements) => {
        elements.searchDropdown.addClass('active');
        elements.searchDropdownOutside.addClass('active');
        elements.mainHeaderText.addClass('active-search');
        setTimeout(() => {
            elements.searchInput.focus();
        }, 200);
    };

    const deactivateSearch = (elements) => {
        elements.searchDropdown.removeClass('active');
        elements.searchDropdownOutside.removeClass('active');
        elements.mainHeaderText.removeClass('active-search');
    };

    const toggleSearch = (elements) => {
        const wasActive = elements.searchDropdown.hasClass('active');

        elements.searchDropdown.toggleClass('active');
        elements.searchDropdownOutside.toggleClass('active');
        elements.mainHeaderText.toggleClass('active-search');

        if (!wasActive) {
            setTimeout(() => {
                elements.searchInput.focus();
            }, 200);
        }
    };

    const isSearchActive = (elements) => {
        return elements.searchDropdown.hasClass('active');
    };

    const setupKeyboardListeners = (elements) => {
        $(window).on('keydown', (e) => {
            if ((e.key === 'F3' || (e.ctrlKey && e.key === 'f')) && !isSearchActive(elements)) {
                e.preventDefault();
                activateSearch(elements);
            }
        });
    };
    const setupClickAwayListener = (elements) => {
        $(document).on('click', (event) => {
            const isClickInsideDropdown = elements.searchDropdown.is(event.target) ||
                elements.searchDropdown.has(event.target).length !== 0;
            const isClickInsideOutside = elements.searchDropdownOutside.is(event.target) ||
                elements.searchDropdownOutside.has(event.target).length !== 0;

            if (!isClickInsideDropdown && !isClickInsideOutside && elements.searchDropdown.hasClass('active')) {
                deactivateSearch(elements);
            }
        });
    };


    const setupRemoveValueButton = (elements) => {
        elements.removeValueButton.hide();

        elements.searchInput.on('input', function() {
            if ($(this).val().length > 0) {
                elements.removeValueButton.fadeIn(200);
            } else {
                elements.removeValueButton.fadeOut(200);
            }
        });

        elements.removeValueButton.on('click', function(e) {
            e.preventDefault();
            elements.searchInput.val('').focus();
            $(this).fadeOut(200);
        });

        if (elements.searchInput.val().length > 0) {
            elements.removeValueButton.show();
        }
    };
    const setupButtonListeners = (elements) => {
        elements.searchButton.on('click', (e) => {
            e.preventDefault();
            activateSearch(elements);
        });

        elements.mainSearchDropdown.on('click', (e) => {
            e.preventDefault();
            toggleSearch(elements);
        });
    };

    const setupAutocomplete = (elements) => {
        const selector = elements.searchInput.attr("id");
        const searchAutocomplete  = new AutoComplete();
        searchAutocomplete.add('#'+selector, APPLICATION + '/service/allgroups/autocomplete_search_cache',{
            onSelect: (event, details) => {
                const selectedItem = details.selection.value;
                window.location.href = selectedItem.url;
                event.target.value = selectedItem.value;
            },
        });
    };

    const init = () => {
        const elements = getDomElements();
        setupKeyboardListeners(elements);
        setupClickAwayListener(elements);
        setupButtonListeners(elements);
        setupRemoveValueButton(elements);
        setupAutocomplete(elements);
    };

    return {
        init: init
    };
})(jQuery);

$(document).ready(function() {
    if($(".search-dropdown").length>0){
        SearchModule.init();
    }
});
